import { useState, type FormEvent } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function Login() {
  const { user, loading, signIn } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  if (!loading && user) {
    return <Navigate to="/scan" replace />;
  }

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);

    const res = await signIn(email.trim(), password);
    if (res.error) setError(res.error);

    setSubmitting(false);
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-background-50 px-4">
      <div className="absolute -left-20 -top-20 h-72 w-72 rounded-full bg-primary-100 blur-3xl" />
      <div className="absolute -bottom-24 -right-16 h-80 w-80 rounded-full bg-accent-100 blur-3xl" />

      <div className="relative w-full max-w-md">
        <div className="mb-6 flex flex-col items-center text-center">
          <div className="mb-4 flex h-14 w-14 items-center justify-center">
            <img
              src="https://storage.helloreaddy.io/project_files/b8583382-38f6-4b44-9388-11a95eaee93e/fa07c2a6-a0eb-4342-b4d2-b90375c04059_compressed_LOGO-NEWLEXBABY-1.webp"
              alt="NewLexBaby"
              className="h-14 w-14 object-contain"
            />
          </div>
          <h1 className="text-2xl font-bold text-foreground-950">NewLexBaby</h1>
        </div>

        <div className="rounded-2xl border border-background-200 bg-white p-6">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="mb-1.5 block text-sm font-medium text-foreground-700">
                Email
              </label>
              <input
                type="email"
                name="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full rounded-lg border border-background-200 bg-background-50 px-3 py-2.5 text-sm text-foreground-950 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
              />
            </div>

            <div>
              <label className="mb-1.5 block text-sm font-medium text-foreground-700">
                Mật khẩu
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="w-full rounded-lg border border-background-200 bg-background-50 px-3 py-2.5 pr-11 text-sm text-foreground-950 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((v) => !v)}
                  aria-label={showPassword ? "Ẩn mật khẩu" : "Hiện mật khẩu"}
                  className="absolute right-2 top-1/2 flex h-7 w-7 -translate-y-1/2 items-center justify-center rounded-md text-foreground-400 transition-colors hover:bg-background-100 hover:text-foreground-700"
                >
                  <i
                    className={`${showPassword ? "ri-eye-off-line" : "ri-eye-line"} text-base`}
                  />
                </button>
              </div>
            </div>

            {error && (
              <div className="rounded-lg bg-accent-100 px-3 py-2.5 text-sm text-accent-800">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={submitting}
              className="w-full whitespace-nowrap rounded-lg bg-primary-500 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {submitting ? "Đang xử lý..." : "Đăng nhập"}
            </button>
          </form>
        </div>

        <p className="mt-4 text-center text-xs text-foreground-400">
          Tài khoản do Quản trị viên cấp. Liên hệ admin nếu bạn chưa có tài khoản.
        </p>
      </div>
    </div>
  );
}